export enum ClickBehaviorType {
	// it is default behavior. I don't know what is reason for hide tooltip on click, but it is happened. 
	// If future almost all areas will be used ImmediatelyShow then we can remove this behavior.
	ImmediatelyHide,
	ImmediatelyShow
}